import { render, staticRenderFns } from "./loadImg.vue?vue&type=template&id=78b10746"
import script from "./loadImg.vue?vue&type=script&lang=js"
export * from "./loadImg.vue?vue&type=script&lang=js"
import style0 from "./loadImg.vue?vue&type=style&index=0&id=78b10746&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports